import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u1856",
  "use": "icon-u1856-usage",
  "viewBox": "0 0 36 20",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 20\" id=\"icon-u1856\">\n  <g transform=\"matrix(1 0 0 1 -671 -128 )\">\n    <path d=\"M 673.19691942695 147  L 689 129.4410215855  L 704.80308057305 147  L 673.19691942695 147  Z \" fill-rule=\"nonzero\" fill=\"#999999\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol